"use client";
import { jsxs as e, jsx as a } from "react/jsx-runtime";
const t = ({
  title: l,
  titleId: n,
  desc: h,
  descId: i,
  ...c
}) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "-.5 -.5 16 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": n,
    "aria-describedby": i,
    ...c,
    children: [
      l ? /* @__PURE__ */ a("title", { id: n, children: l }) : null,
      h === void 0 ? /* @__PURE__ */ a("desc", { id: i, children: `
    Building Thin Streamline Icon: https://streamlinehq.com
  ` }) : h ? /* @__PURE__ */ a("desc", { id: i, children: h }) : null,
      /* @__PURE__ */ a("path", { d: "M14.5778 14.3056h-1.9056V.6944h.8167c.2095-.0003.3402-.2273.2351-.4086A.272.272 0 0 0 13.489.15H1.511c-.2095.0003-.3402.2273-.2351.4087a.272.272 0 0 0 .2351.1357h.8167v13.6112H.4222c-.2095.0003-.3402.2273-.2351.4086a.272.272 0 0 0 .2351.1358h14.1556c.2095-.0003.3402-.2273.2351-.4087a.272.272 0 0 0-.2351-.1357M2.8722.6944h9.2556v13.6112H9.4056V11.311a.272.272 0 0 0-.2723-.2722H5.8667a.272.272 0 0 0-.2723.2722v2.9945H2.8722Zm5.989 13.6112H6.1388v-2.7223H8.861ZM5.05 3.1444a.272.272 0 0 1 .2722-.2722h1.089c.2095.0003.3401.2274.235.4087a.272.272 0 0 1-.235.1358h-1.089a.272.272 0 0 1-.2722-.2723m3.2667 0a.272.272 0 0 1 .2722-.2722h1.0889c.2095.0003.3402.2274.2351.4087a.272.272 0 0 1-.2351.1358h-1.089a.272.272 0 0 1-.2721-.2723M5.05 5.8667a.272.272 0 0 1 .2722-.2723h1.089c.2095.0004.3401.2274.235.4087a.272.272 0 0 1-.235.1358h-1.089a.272.272 0 0 1-.2722-.2722m3.2667 0a.272.272 0 0 1 .2722-.2723h1.0889c.2095.0004.3402.2274.2351.4087a.272.272 0 0 1-.2351.1358h-1.089a.272.272 0 0 1-.2721-.2722M5.3222 8.861c-.2095-.0003-.3402-.2273-.2351-.4087a.272.272 0 0 1 .2351-.1357h1.089c.2095.0003.3401.2273.235.4086a.272.272 0 0 1-.235.1358Zm2.9945-.2722a.272.272 0 0 1 .2722-.2722h1.0889c.2095.0003.3402.2273.2351.4086a.272.272 0 0 1-.2351.1358h-1.089a.272.272 0 0 1-.2721-.2722" })
    ]
  }
);
export {
  t as default
};
